import { ACTIONS } from '../actions';

const INITIAL_STATE = {
    planName: ''
}

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case ACTIONS.GET_PLAN:
            return { ...state, planName: action.payload.planName };
        default:
            return state;
    }
}
